<template>
  <section class="admin-content " id="contact-search">
    <Navbar/>
    <main class="admin-main">
       <div class="bg-dark m-b-30">
           <div class="container">
               <div class="row p-b-60 p-t-60">

                   <div class="col-md-6 text-center mx-auto text-white p-b-30">
                       <h3 class="h3">Register TPA</h3>
                   </div>


               </div>
           </div>
       </div>
       <section class="">
           <div class="container">

               <div class="row list">

                   <div class="col-md-12">
                     <div class="card m-b-30">
                       <div class="card-body">

                         <div class="form-row">
                           <div class="form-group floating-label col-md-6">
                               <label>First Name</label>
                               <input type="text" required class="form-control" placeholder="First Name" v-model="register.firstname">
                           </div>
                           <div class="form-group floating-label col-md-6">
                               <label>Last Name</label>
                               <input type="text" required class="form-control" placeholder="Last Name" v-model="register.lastname">
                           </div>

                           <div class="form-group floating-label col-md-6">
                               <label>Organization Name</label>
                               <input type="text" required class="form-control" placeholder="Organization Name" v-model="register.organization_name">
                           </div>

                             <div class="form-group floating-label col-md-6">
                                 <label>Phone Number</label>
                                 <input v-phone type="text" required class="form-control" placeholder="Phone Number" v-model="register.phone_number">
                             </div>
                             <div class="form-group floating-label col-md-4">
                                 <label>Email</label>
                                 <input type="email" required class="form-control" placeholder="Email" v-model="register.email">
                             </div>
                             <div class="form-group floating-label col-md-4">
                                 <label>Password</label>
                                 <input type="password" required class="form-control" placeholder="Password" v-model="register.password">
                             </div>
                             <div class="form-group floating-label col-md-4">
                                 <label>Confirm Password</label>
                                 <input type="password" required class="form-control" placeholder="Password" v-model="register.password_confirmation">
                             </div>
                       </div>

                         <button @click="registerUser" class="btn btn-primary btn-block btn-lg">Add TPA</button>

                       </div>
                     </div>

                   </div>

               </div>
           </div>


           <div class="vld-parent">
                <loading :active.sync="isLoading"
                loader="dots"
                :can-cancel="true"
                :is-full-page="fullPage"></loading>
            </div>

       </section>
    </main>
   </section>
</template>

<script>
  import Navbar from '@/views/Navbar.vue'
  // Import component
     import Loading from 'vue-loading-overlay';
     // Import stylesheet
     import 'vue-loading-overlay/dist/vue-loading.css';
     // Init plugin


export default {
  components: {
     Navbar, Loading
  },
  data(){
    return{
      user:null,
      providers:"",
      agencies:"",
      edit:false,
      show:false,
      isLoading: false,
      fullPage: true,
      tpas:"",
      register:{

                email:"",
                phone_number:"",
                state:"",
                agency_name:"",
                ward:"",
                services_offered:"",
                localgovt:"",
                address1:"",
                role:0,
                password:"",
                password_confirmation:""
            }
    }
  },
  beforeMount(){
    this.user = JSON.parse(localStorage.getItem('user'))
    this.axios.get(`/api/v1/auth/orgenrollment`)
                .then(response => {
                    this.tpas = response.data.data
                    console.log(response)
                })
                .catch(error => {
                    console.error(error);
                })
  },
  methods:{

    registerUser(){
      this.user = JSON.parse(localStorage.getItem('user'))
        this.isLoading = true;
        this.axios.post('/api/v1/auth/registerProvider',{
          email : this.register.email,
          phone_number : this.register.phone_number,
          agency_name : this.register.agency_name,
          firstname : this.register.firstname,
          lastname : this.register.lastname,
          state : '2683',
          localgovt : '767',
          type : 'tpa',
          password : this.register.password,
          password_confirmation : this.register.password_confirmation,
          enrolled_by : 0,
        })
        .then(response=>{
          // let user_id = response.data.data.id

            // add Organization
              this.show = false;
              console.log(response)
              this.axios.post('/api/v1/auth/orgenrollment',{
                email : this.register.email,
                phone_number : this.register.phone_number,
                organization_name : this.register.organization_name,
                agency_id : this.user.id,

                  })

                  .then(response=>{
                      console.log(response);
                      this.getTPAs()
                      this.$toasted.info('Organization added Successfully!', {position: 'top-left', duration:5000 })

                  })
                  .catch(error=>{
                      console.log(error.response)
                  })
                  // end of Organization

            console.log(response);
            this.isLoading = false;

        })
        .catch(error=>{
            console.log(error.response)
            this.isLoading = false;
            this.$toasted.error('Sign up not Successful', {position: 'top-left', duration:5000 })

        })
    },



  },
  created(){
  //
  }

}
</script>
